import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { Link } from "react-router-dom";

const menu = [
  { path: "/library/dashboard", label: "Dashboard" },
  { path: "/library/books", label: "Books" },
  { path: "/library/members", label: "Members" },
  { path: "/library/rentals", label: "Rentals" },
  { path: "/library/payments", label: "Payments" },
  { path: "/library/reports", label: "Reports" },
];

const SidebarMenu = () => {
  const userData = JSON.parse(sessionStorage.getItem("userData")) || {};
  const menuFiltered = menu.filter((item) => {
    if (userData.branch === "Rehoboth") {
      return (
        item.path !== "/library/payments" && item.path !== "/library/members"
      );
    }
    return true;
  });

  return (
    <Nav vertical className="bg-light p-3 sidebar">
      {menuFiltered.map((item, index) => (
        <NavItem key={index}>
          <NavLink tag={Link} to={item.path}>
            {item.label}
          </NavLink>
        </NavItem>
      ))}
      <NavItem>
        <NavLink
          href="#"
          onClick={() => {
            sessionStorage.removeItem("userData");
            window.location.href = "/"; // or use useNavigate if in component
          }}
        >
          Logout
        </NavLink>
      </NavItem>
    </Nav>
  );
};

export default SidebarMenu;
